module.exports = __webpack_public_path__ + "img/computer_four_guide.4baba31a.png";